__turbopack_context__.v({
  "className": "urbanist_a7806bee-module__6luYPq__className",
});
